<template>
<!--
  Note: Put most important message first because we can only one notification at a time or the layout will break
-->
  <!-- At Record Limit -->
  <div v-if="isAtRecordLimit" class="notification_bar is_red">
    <p class="notification_bar--message">
      You're at your limit of {{ account.record_limit }} leads. <a class="notification_bar--link" @click="openBillingPortal">Upgrade Your Account</a> to get more leads.
    </p>
  </div>

  <!-- Near Record Limit -->
  <div v-else-if="isNearRecordLimit" class="notification_bar is_yellow">
    <p class="notification_bar--message">
      You're getting close to your limit of {{ account.record_limit }} leads. <a class="notification_bar--link" @click="openBillingPortal">Upgrade Your Account</a> to get more leads.
    </p>
  </div>
</template>

<script>
export default {
  name: "PageNotification",
  computed: {
    account() {
      return this.$store.getters.account;
    },
    isNearRecordLimit() {
      return this.account.is_near_record_limit;
    },
    isAtRecordLimit() {
      return this.account.is_at_record_limit;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.notification_bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2;
  height: $notificationHeight;
  padding: 0 20px;

  &.is_red {
    background-color: $red;
  }

  &.is_yellow {
    background-color: $yellow;
  }

  &.is_green {
    background-color: $green;
  }

  &--message {
    color: $white;
    font-size: 0.875rem;
    text-align: center;
    font-weight: bold;
    line-height: $notificationHeight;
  }

  &--link {
    color: $white;
    text-decoration: underline;
  }
}

</style>
